/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *  FlagIcon Icon
 * @author Anuja Gaikwad
 * @file FlagIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function FlagIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12213 8.53675V13.8853C4.12213 14.1046 4.04673 14.2897 3.89592 14.4406C3.745 14.5914 3.55989 14.6668 3.34061 14.6668C3.12132 14.6668 2.93622 14.5914 2.78529 14.4406C2.63449 14.2897 2.55908 14.1046 2.55908 13.8853V2.11502C2.55908 1.89574 2.63449 1.71063 2.78529 1.55971C2.93622 1.4089 3.12132 1.3335 3.34061 1.3335H12.6617C12.8042 1.3335 12.9316 1.36625 13.0439 1.43175C13.1563 1.49713 13.2453 1.5825 13.3108 1.68784C13.3762 1.79319 13.4175 1.90845 13.4346 2.03361C13.4518 2.15888 13.4334 2.28696 13.3795 2.41784L12.3421 4.9371L13.3795 7.45241C13.4334 7.58329 13.4511 7.71137 13.4326 7.83664C13.414 7.9618 13.3721 8.07706 13.3067 8.1824C13.2412 8.28764 13.1529 8.373 13.0418 8.4385C12.9309 8.504 12.8042 8.53675 12.6617 8.53675H4.12213Z"
        fill="#2E2E2E"
      />
    </SvgIcon>
  );
}

export default FlagIcon;

